module.exports = __webpack_public_path__ + "static/media/sidebar_icon_alt.65a55ba1.svg";